// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

interface GenericErrorModalProps {
	title: string;
	message: React.ReactNode;
}
export const GenericErrorModal: React.FC<GenericErrorModalProps> = observer(({title, message}) => {
	const {t} = useLingui();
	return (
		<ConfirmModal
			title={title}
			description={message}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
